import { useLazyQuery } from "@vue/apollo-composable";

import type {
  QuickSearchProductsQueryResult,
  QuickSearchProductsQueryVariables,
} from "./quickSearch.gql";
import { QUICK_SEARCH_PRODUCTS } from "./quickSearch.gql";

export function useQuickSearchProductsQuery() {
  return useLazyQuery<QuickSearchProductsQueryResult, QuickSearchProductsQueryVariables>(
    QUICK_SEARCH_PRODUCTS,
  );
}
